import { useEffect, useState } from 'react';
import { getChildItemTotalWidth } from '../helpers';
import useElementResize from './use-element-resize';

const useOffset = (
  carouselRef,
  childrenRef,
  currentItem,
  additionalOffset = 0
) => {
  const [elementResize] = useElementResize();
  const [offset, setOffset] = useState({
    prev: 0,
    current: 0,
    showAllItems: false
  });

  useEffect(() => {
    const totalContainerWidth =
      carouselRef.current?.getBoundingClientRect().width + additionalOffset;
    const showAllItems =
      getChildItemTotalWidth(childrenRef) <= totalContainerWidth;
    const outerMid = totalContainerWidth / 2;
    const currentTileWidth = childrenRef?.current?.children[
      currentItem
    ].getBoundingClientRect().width;
    const tileMid = currentTileWidth / 2;
    const marginSize = 0;

    const leftOffsetCalc =
      outerMid -
      tileMid -
      2 * currentItem -
      currentTileWidth * currentItem -
      marginSize * currentItem;

    setOffset(prevState => ({
      previous: prevState.current,
      current: showAllItems ? 0 : leftOffsetCalc,
      showAllItems
    }));
  }, [currentItem, elementResize]);

  return offset;
};

export default useOffset;
